// DeleteConfirmationModal.js
import React from 'react';
import './DeleteConfirmationModal.css'

const DeleteConfirmationModal = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="confirmation-modal">
      <div className="confirmation-modal-content">
        <h3 className='confirmation-title'>Confirm Deletion</h3>
        <label className='confirmQues'>Are you sure you want to delete this form?</label>
        <div className='confirmCont'>
            <div className='yesCont'>
                <button className='yesBtn' onClick={onConfirm}>Yes</button>
            </div>
            <div className='noCont'>
                <button className='noBtn' onClick={onCancel}>No</button>
            </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
